// extracted by mini-css-extract-plugin
export var gif = "_kz-0";